@if (formGroup) {
    <div class="flex flex-col gap-7 justify-between" style="height: 100%">
        <form [formGroup]="$any(formGroup)" class="flex flex-col gap-7 mt-6">
            <z-float-label
                [label]="'MyData User Name'"
                formControlName="MyDataUser"
            ></z-float-label>

            <z-float-label
                [label]="'MyData Key'"
                formControlName="MyDataKey"
            ></z-float-label>
        </form>

        <div class="flex grow flex-wrap gap-4 justify-between items-end">
            <!-- <p-button label="Ακύρωση" severity="secondary" /> -->
            <div></div>

            <p-button label="Αποθήκευση" (onClick)="saveUserApiInfo()" />
        </div>
    </div>
}
